import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { VhViethasWebAPPEndUser } from 'vhwebapp';
import { Platform } from '@ionic/angular';
import path from '../../config/path/path.json'
@Component({
  selector: 'app-webapp-fields-user-c001',
  templateUrl: './webapp-fields-user-c001.component.html',
  styleUrls: ['./webapp-fields-user-c001.component.scss']
})
export class WebappFieldsUserC001Component implements OnInit {
  public listFields: any = [];
  isMobile: boolean;
  @Output() close = new EventEmitter<any>();
  closeMe: boolean;
  constructor(
    private vhViethasWebAPPEndUser: VhViethasWebAPPEndUser,
    private router: Router,
    public platform: Platform,
  ) {
    if (this.platform.is('desktop')) this.isMobile = false;
    else this.isMobile = true;
  }

  ngOnInit(): void {
    this.getMenuFields()
  }

  getMenuFields() {
    this.vhViethasWebAPPEndUser.getComponentContentsByFields('webapp_fields_c001s', { status: { $eq: true } }, {}, {}, 0, 0)
      .then((response: any) => {
        if (response.vcode === 0) {
          //-----------your code-----------
          this.listFields = response.data
        }
      }, error => {
        console.log('error', error)
      })
  }

  gotoFields(_id) {
    let router = path.link + "/" + _id
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.router.navigateByUrl(router)
  }

  closeMenu() {
    this.closeMe = false;
    this.close.emit(this.closeMe)
  }

}
